import { render, staticRenderFns } from "./SideBar.vue?vue&type=template&id=5f850629&scoped=true&"
import script from "./SideBar.vue?vue&type=script&lang=js&"
export * from "./SideBar.vue?vue&type=script&lang=js&"
import style0 from "../assets/scss/sidebar.scss?vue&type=style&index=0&id=5f850629&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f850629",
  null
  
)

export default component.exports